var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"QRCode",style:({'width':'100%', 'height':'100%'})},[_c('canvas',{style:({'width':'100%', 'height':'100%'}),attrs:{"id":_vm.canvasId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }